import { injectable } from "inversify";
import ShiftRepository from "../../../domain/repositories/ShiftRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import ShiftEntity from "../../../domain/entities/ShiftEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import SearchShiftsApiImpl from "./api/SearchShiftsApiImpl";
import CreateShiftApiImpl from "./api/CreateShiftApiImpl";
import GetShiftByIdApiImpl from "./api/GetShiftByIdApiImpl";
import DeleteShiftApiImpl from "./api/DeleteShiftApiImpl";
import UpdateShiftApiImpl from "./api/UpdateShiftApiImpl";
import reasingShiftApiImpl from "./api/ReasingShiftApiImpl";

@injectable()
export default class ShiftRepositoryImpl implements ShiftRepository {
    createShiftWithSchedule = (_:{scheduleId: string, date: Date, userId: string}): Promise<Either<ErrorEntity, ShiftEntity>> => CreateShiftApiImpl(_);
    reasignShift = (_:{
        shiftId: string, newUserId: string, oldUserId: string, reason: string
    }) => reasingShiftApiImpl(_);
    searchShifts = (params: import("../../../domain/repositories/ShiftRepository").SearchShiftsParams): Promise<Either<ErrorEntity, SearchResultEntity<ShiftEntity>>> => SearchShiftsApiImpl(params);
    getShiftById = (id: string): Promise<Either<ErrorEntity, ShiftEntity>> => GetShiftByIdApiImpl(id);
    deleteShift = (id: string): Promise<Either<ErrorEntity, void>> => DeleteShiftApiImpl(id);
    updateShift = (shift: ShiftEntity): Promise<Either<ErrorEntity, ShiftEntity>> => UpdateShiftApiImpl(shift);
}